import React, {
  useState,
  useEffect,
  useImperativeHandle,
  forwardRef,
} from "react";
import { smsCode } from "@/service/user";
import { VerifyType } from "@/service/user/enum";
import { message as messageToast } from "antd";
import { StatusCode } from "@/utils/statusCode";

export interface CountdownRef {
  sendCode: (email: string, type: VerifyType) => void;
  startCountdown: () => void;
}

type CountdownProps = {
  children: React.ReactNode;
  ref?: React.ForwardedRef<CountdownRef>;
  onClick?: () => void;
};

export const Countdown = forwardRef<CountdownRef, CountdownProps>(
  ({ children, onClick }, ref) => {
    const [countdown, setCountdown] = useState(0);
    const [isDisabled, setIsDisabled] = useState(false);

    // 暴露给父组件的属性，open是打开抽屉的方法
    useImperativeHandle(ref, () => ({
      sendCode: (email: string, type: VerifyType) => {
        handleGetCode(email, type);
      },
      startCountdown: () => {
        startCountdown();
      },
    }));

    const startCountdown = () => {
      let remainingTime = 60;
      setCountdown(remainingTime);
      setIsDisabled(true);

      const intervalId = setInterval(() => {
        remainingTime -= 1;
        setCountdown(remainingTime);

        if (remainingTime <= 0) {
          clearInterval(intervalId);
          setIsDisabled(false);
          setCountdown(0);
        }
      }, 1000);

      // 清理定时器
      return () => clearInterval(intervalId);
    };

    const handleGetCode = async (email: string, type: VerifyType) => {
      try {
        const { status, message } = await smsCode({ email, type });

        if (status === 200) {
          messageToast.success(message);
          startCountdown();
        } else if (status === StatusCode.TriggerRateLimit) {
          onClick?.();
        } else {
          messageToast.error(message);
        }
      } catch (error) {
        // 如果请求失败，恢复按钮状态
        setIsDisabled(false);
        setCountdown(0);
      }
    };

    useEffect(() => {
      // 清理定时器
      return () => {
        clearInterval(countdown);
      };
    }, [countdown]);

    return (
      <div className="inline-block text-bravve-sub-100">
        <span
          className={`${isDisabled ? "pointer-events-none border-b border-bravve-300 leading-22 text-bravve-300" : "border-b border-bravve-100 text-bravve-100"}`}
        >
          {children}
        </span>
        <span className="inline-block w-30">
          {countdown > 0 ? `${countdown}s` : ""}
        </span>
      </div>
    );
  },
);
